import { useMutation, useQueryClient } from 'react-query';
import { publishTournament, cancelTournament, pauseTournament, resumeTournament } from '../api/tournament';
import { QueryKeys } from '../constants';
import { StatusAction } from '../api/tournamentStatusTransitions';

export const useUpdateTournamentStatus = () => {
    const queryClient = useQueryClient();

    return useMutation(
        async (params: { id: number; action: StatusAction }) => {
            const { id, action } = params;
            switch (action) {
                case 'publish':
                    await publishTournament(id);
                    break;
                case 'cancel':
                    await cancelTournament(id);
                    break;
                case 'pause':
                    await pauseTournament(id);
                    break;
                case 'resume':
                    await resumeTournament(id);
                    break;
                default:
                    throw new Error(`Unknown action: ${action}`);
            }
        },
        {
            onSuccess: (_, params) => {
                queryClient.invalidateQueries(QueryKeys.tournaments);
                queryClient.invalidateQueries([QueryKeys.tournament, params.id]);
            },
        }
    );
};
